import useMerchantWebPortalAxios from "../../utils/axiosWeb";
import { settingBillsData } from "../../features/billsPageSlice";
import { useDispatch } from "react-redux";
import useResponse from "../../app/useResponse";

function useSodetelApi() {
  const dispatch = useDispatch();
  const MerchantWebPortalAxios = useMerchantWebPortalAxios();
  const { successResponse, errorResponse } = useResponse();
  const errorRes = {
    response: {
      data: {
        isPopup: true,
        PopupTitle: "Error",
        PopupDescription: "Something went wrong. Please try again later.",
      },
    },
  };

  const checkWebKey = async () => {
    const res = await MerchantWebPortalAxios.get(`/api/sodetel`);
    return res.data;
  };

  const getSodetelCards = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/sodetel/bundles`, payload);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status && res?.data?.data?.requestId) {
        dispatch(settingBillsData({ field: "prepaidRes", value: res?.data?.additionalData }));
        return res.data;
      } else {
        successResponse(res?.data?.data?.Popup);
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  const sodetelRefill = async (payload) => {
    try {
      dispatch(settingBillsData({ field: "isloading", value: "loading" }));
      const res = await MerchantWebPortalAxios.post(`/api/sodetel/refill`, payload);
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      if (res.data.status) {
        dispatch(settingBillsData({ field: "prepaidRes", value: res?.data?.data?.Popup }));
        return res.data;
      } else {
        return res.data;
      }
    } catch (error) {
      dispatch(settingBillsData({ field: "isloading", value: "idle" }));
      errorResponse(errorRes);
    }
  };

  return {
    checkWebKey,
    getSodetelCards,
    sodetelRefill,
  };
}

export default useSodetelApi;
